import { Component } from '@angular/core';

@Component({
    //selector: 'fi-editor-page-header,fi-editor-page-sidebar,fi-editor-page-content',
    selector: 'fi-editor-page-header-old,fi-editor-page-sidebar,fi-editor-page-content',
    template: '<ng-content></ng-content>',
    standalone: false,
})
export class FiEditorPageTranscludeComponent {}
